<mat-dialog-content>
  @if (bulkUpdate) {
    <p>
      <b>Would you like to set all profiles to {{ status }} in all workspaces?</b>
    </p>
  } @else {
    <p>
      <b
        >Would you like to set {{ data?.personName }} to {{ status }} in all
        workspaces?</b
      >
    </p>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-flat-button color="primary" (click)="update()">
    @if (bulkUpdate) {
      Yes, set profiles to {{ status }} everywhere
    } @else {
      Yes, set profile to {{ status }} everywhere
    }
  </button>
  <button type="button" mat-stroked-button (click)="updateInOrg()">
    No, just the org
  </button>
  <button type="button" mat-stroked-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>
